/*
 * facet-collapse.js
 * Lets a shopper collapse the always-visible filter column on collection pages.
 * The choice persists via localStorage and re-applies after AJAX facet re-renders.
 * Layout, label swap, and visibility are CSS-driven; this only manages state and aria.
 */
(function () {
  var KEY = 'pl:filters-collapsed';

  function isCollapsed() {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function store(v) {
    try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {}
  }

  function apply() {
    var collapsed = isCollapsed();
    var facets = document.querySelectorAll('.product-facet');
    for (var i = 0; i < facets.length; i++) {
      var pf = facets[i];
      pf.classList.toggle('is-aside-collapsed', collapsed);
      var btns = pf.querySelectorAll('[data-facet-collapse]');
      for (var j = 0; j < btns.length; j++) {
        btns[j].setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      }
    }
  }

  // Toggle via event delegation so it survives section re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-facet-collapse]') : null;
    if (!btn) return;
    store(!isCollapsed());
    apply();
  });

  // Re-apply after the Section Rendering API swaps the facet contents.
  function observe() {
    var pf = document.querySelector('.product-facet');
    if (!pf || !window.MutationObserver) return;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.setTimeout(function () { pending = false; apply(); }, 0);
    });
    mo.observe(pf, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(); observe(); });
  } else {
    apply(); observe();
  }
})();
